import { Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import { BadgeCheck } from "lucide-react";

import { getDistrictForPlace } from "@/lib/districts.functions";
import { DistrictLink } from "@/components/districts/DistrictLink";

/** Renders "Part of <district>" when this venue belongs to a published district hub. */
export function DistrictLinkBanner({ placeSlug }: { placeSlug: string }) {
  const fetchFn = useServerFn(getDistrictForPlace);
  const { data } = useQuery({
    queryKey: ["district-for-place", placeSlug],
    queryFn: () => fetchFn({ data: { slug: placeSlug } }),
    staleTime: 10 * 60_000,
  });

  if (!data) return null;

  return (
    <DistrictLink
      slug={data.slug}
      style={{ textTransform: "none" }}
      className="mt-3 inline-flex items-center gap-1.5 rounded-full border border-royal/20 bg-royal/5 px-3 py-1.5 text-[11px] font-semibold text-royal transition-colors hover:bg-royal/10"
    >
      <BadgeCheck className="size-3.5" />
      Part of {data.name}
    </DistrictLink>
  );
}

export default DistrictLinkBanner;
